export const LOADER_TYPE_DEFAULT = 'loading';
export const LOADER_TYPE_PROCESSING = 'processing';
